export class User {
  operationStatus: string;
  operationMessage: string;
  status: boolean;
  item: {
    phone: string;
    email: string;
    token: string;
    userId: string;
    firstName: string;
    lastName: string;
    userAccountId: any;
    appRoles: string;
    clientlogopath: string;
    mytodolength: number
    msgcount: number;
    documentCount: number;
    imagepath: string;
    onBehalf: boolean;
    carePartnerPatientName: string
    careFamilyShow: boolean;
    welcomeFlag: boolean;
    DeidFlag: boolean;
    userAccountKey: string;
    patientCreatedBy: string;
    availSecurity: boolean;
    clientType: string;
    selectCNUserId: string;
    userrole: string;
    userdisplayrole: string;
    userGroupId: number;
    cnmappingct: number;
    commercialType: boolean;
    pqtlength: number;
    landingPage: string;
    phoneFormat: string;
    hostModel: string;
    dateFormat: string;
    currencyFormat: string;
    language: string;
    length: number;
    salutation: string;
    rcOnBoard: any,
    setmask: string;
    helpDeskNo: string;
    securityAnswerEmpty: boolean;
    userMode: string;
    patientId: string;
    demoSite: boolean;
    superClient: boolean;
    allowOnboard: boolean;
    passwordExpired: boolean;
    allowPasswordChange: boolean;
    irrelevantAnswer: boolean;
    userimagepath: string;
    clientCountryCode: string;
    clientTeleCode: string;
    cnDropDown: boolean;
    bundleStatus: boolean;
    bundleEndDateStatus: boolean;
    tempPasswordActive: boolean;
    credResetRequired: boolean;
    officeStaff: boolean;
    coachEnabled:boolean;
    lastLoginDate : Date;
    
  };
}
